import { ActionTypes } from '../actionTypes';
import { GoalAnalyticsData, GoalPerformanceRequest } from '../../types';

export const fetchGoalPerformanceRequest = (queryData: GoalPerformanceRequest) => ({
  type: ActionTypes.FETCH_GOAL_PERFORMANCE_REQUEST,
  queryData,
});

export const fetchGoalPerformanceResponse = (metrics: GoalAnalyticsData) => ({
  type: ActionTypes.FETCH_GOAL_PERFORMANCE_RESPONSE,
  payload: metrics,
});

export const fetchGoalPerformanceError = () => ({
  type: ActionTypes.FETCH_GOAL_PERFORMANCE_ERROR,
});
